/**
 * MACHU POSTER - Theme JavaScript
 * Elegant, klassisch, minimalistisch
 */

document.addEventListener('DOMContentLoaded', function() {
  initMobileMenu();
  initNavDropdowns();
  initSlider();
  initFilterSidebar();
  initProductSearch();
  initFilterGroups();
  initQuantitySelectors();
  initProductGallery();
});

/**
 * Mobile Menu
 */
function initMobileMenu() {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-main-nav]');
  
  if (!toggle || !nav) return;
  
  toggle.addEventListener('click', function() {
    this.classList.toggle('is-active');
    nav.classList.toggle('is-open');
    document.body.style.overflow = nav.classList.contains('is-open') ? 'hidden' : '';
  });
  
  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) {
      toggle.classList.remove('is-active');
      nav.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });
}

/**
 * Navigation Dropdowns (mobile toggle + desktop hover close on click outside)
 */
function initNavDropdowns() {
  var dropdowns = document.querySelectorAll('[data-nav-dropdown]');
  dropdowns.forEach(function(item) {
    var link = item.querySelector('.nav-link');
    if (!link) return;

    link.addEventListener('click', function(e) {
      // On mobile: toggle dropdown, prevent navigation
      if (window.innerWidth <= 992) {
        e.preventDefault();
        item.classList.toggle('is-open');
      }
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    dropdowns.forEach(function(item) {
      if (!item.contains(e.target)) {
        item.classList.remove('is-open');
      }
    });
  });
}

/**
 * Hero Slider
 *
 * Touch-first: horizontales Ziehen folgt dem Finger, vertikales Scrollen bleibt
 * unangetastet (Richtungs-Lock). Autoplay läuft über genau EIN Intervall und
 * pausiert, sobald der Tab im Hintergrund liegt oder der Nutzer den Slider anfasst.
 */
function initSlider() {
  const sliders = document.querySelectorAll('[data-slider]');

  sliders.forEach(slider => {
    const track = slider.querySelector('[data-slider-track]');
    if (!track) return;

    const dots = slider.querySelectorAll('[data-slider-dot]');
    const prevBtn = slider.querySelector('[data-slider-prev]');
    const nextBtn = slider.querySelector('[data-slider-next]');
    const slides = track.children;
    const slideCount = slides.length;

    if (slideCount < 2) return;

    const SWIPE_THRESHOLD_RATIO = 0.15; // 15 % der Slider-Breite
    const SWIPE_THRESHOLD_MAX = 90;     // aber nie mehr als 90 px
    const DIRECTION_LOCK_PX = 10;       // ab hier steht fest: horizontal oder vertikal

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = slider.dataset.autoplay !== 'false' && !reduceMotion;
    const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed, 10) || 5000;
    const stepPercent = 100 / slideCount; // Track ist slideCount × 100 % breit

    let currentSlide = 0;
    let autoplayTimer = null;
    let isDragging = false;
    let dragAxis = null; // null | 'x' | 'y'
    let startX = 0;
    let startY = 0;
    let deltaX = 0;

    /* ---------- Positionierung ---------- */

    function setTransform(offsetPx) {
      const base = -(currentSlide * stepPercent);
      track.style.transform = offsetPx
        ? `translateX(calc(${base}% + ${offsetPx}px))`
        : `translateX(${base}%)`;
    }

    function setTransition(on) {
      track.style.transition = on
        ? 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
        : 'none';
    }

    function goToSlide(index) {
      currentSlide = (index % slideCount + slideCount) % slideCount;
      setTransition(true);
      setTransform(0);

      dots.forEach((dot, i) => {
        const active = i === currentSlide;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    const nextSlide = () => goToSlide(currentSlide + 1);
    const prevSlide = () => goToSlide(currentSlide - 1);

    /* ---------- Autoplay: immer nur ein Intervall ---------- */

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || document.hidden) return;
      autoplayTimer = setInterval(nextSlide, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer !== null) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function resetAutoplay() {
      startAutoplay();
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    /* ---------- Maus/Tastatur ---------- */

    if (prevBtn) {
      prevBtn.addEventListener('click', () => { prevSlide(); resetAutoplay(); });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => { nextSlide(); resetAutoplay(); });
    }

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        goToSlide(parseInt(dot.dataset.sliderDot, 10) || 0);
        resetAutoplay();
      });
    });

    slider.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { prevSlide(); resetAutoplay(); }
      else if (e.key === 'ArrowRight') { nextSlide(); resetAutoplay(); }
    });

    // Hover-Pause nur auf echten Zeigergeräten – auf Touch feuert das Browser-
    // emulierte mouseenter/mouseleave sonst ständig und würgt das Autoplay ab.
    if (window.matchMedia('(hover: hover)').matches) {
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
    }

    /* ---------- Touch: ziehen mit Richtungs-Lock ---------- */

    function onTouchStart(e) {
      if (e.touches.length !== 1) return;
      isDragging = true;
      dragAxis = null;
      deltaX = 0;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      stopAutoplay();
      setTransition(false);
    }

    function onTouchMove(e) {
      if (!isDragging || e.touches.length !== 1) return;

      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;

      if (dragAxis === null) {
        if (Math.abs(dx) < DIRECTION_LOCK_PX && Math.abs(dy) < DIRECTION_LOCK_PX) return;
        dragAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (dragAxis === 'y') {
          // Vertikal: Slider loslassen, Seite normal scrollen lassen
          endDrag(false);
          return;
        }
      }

      if (dragAxis === 'x') {
        deltaX = dx;
        // An den Rändern zäher machen, damit es sich nicht „kaputt" anfühlt
        const atStart = currentSlide === 0 && dx > 0;
        const atEnd = currentSlide === slideCount - 1 && dx < 0;
        setTransform(atStart || atEnd ? dx * 0.35 : dx);
      }
    }

    function endDrag(applySwipe) {
      if (!isDragging) return;

      const wasHorizontal = dragAxis === 'x';
      isDragging = false;
      dragAxis = null;
      setTransition(true);

      if (applySwipe && wasHorizontal) {
        const threshold = Math.min(slider.offsetWidth * SWIPE_THRESHOLD_RATIO, SWIPE_THRESHOLD_MAX);
        if (deltaX <= -threshold) currentSlide += 1;
        else if (deltaX >= threshold) currentSlide -= 1;
        goToSlide(currentSlide);
      } else {
        setTransform(0);
      }

      deltaX = 0;
      startAutoplay();
    }

    // touchmove darf nicht passiv sein: bei horizontalem Zug unterbinden wir
    // das native Scrollen, damit das Ziehen sauber am Finger klebt.
    slider.addEventListener('touchstart', onTouchStart, { passive: true });
    slider.addEventListener('touchmove', e => {
      onTouchMove(e);
      if (dragAxis === 'x' && e.cancelable) e.preventDefault();
    }, { passive: false });
    slider.addEventListener('touchend', () => endDrag(true), { passive: true });
    slider.addEventListener('touchcancel', () => endDrag(false), { passive: true });

    /* ---------- Parallax (nur Maus/Trackpad, nie auf Touch) ---------- */

    const slideImages = slider.querySelectorAll('.slide-image');
    const wantsParallax = window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduceMotion;

    if (wantsParallax) {
      slider.classList.add('has-parallax');
      let ticking = false;

      const applyParallax = () => {
        ticking = false;
        const rect = slider.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > window.innerHeight + 100) return;
        const center = rect.top + slider.offsetHeight / 2;
        const progress = (center - window.innerHeight / 2) / window.innerHeight;
        const offset = -progress * 40;
        slideImages.forEach(img => {
          img.style.transform = `translate3d(0, ${offset}px, 0)`;
        });
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(applyParallax);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      applyParallax();
    }

    /* ---------- Start ---------- */

    goToSlide(0);
    startAutoplay();
  });
}

/**
 * Filter Sidebar
 */
function initFilterSidebar() {
  const sidebar = document.querySelector('[data-filter-sidebar]');
  const toggleMobile = document.querySelector('[data-filter-toggle-mobile]');
  const closeBtn = document.querySelector('[data-filter-close]');
  
  if (!sidebar) return;
  
  if (toggleMobile) {
    toggleMobile.addEventListener('click', () => {
      sidebar.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      sidebar.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }
  
  // Close on click outside
  document.addEventListener('click', (e) => {
    if (sidebar.classList.contains('is-open') && 
        !sidebar.contains(e.target) && 
        !toggleMobile?.contains(e.target)) {
      sidebar.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });
}

/**
 * Product Search Filter
 */
function initProductSearch() {
  const searchInput = document.querySelector('[data-product-search]');
  const productGrid = document.querySelector('[data-product-grid]');
  
  if (!searchInput || !productGrid) return;
  
  searchInput.addEventListener('input', debounce(function() {
    const searchTerm = this.value.toLowerCase().trim();
    const products = productGrid.querySelectorAll('.product-card');
    
    products.forEach(product => {
      const title = product.querySelector('.product-title')?.textContent.toLowerCase() || '';
      const visible = !searchTerm || title.includes(searchTerm);
      product.style.display = visible ? '' : 'none';
    });
  }, 300));
}

/**
 * Filter Groups (Accordion)
 */
function initFilterGroups() {
  const toggles = document.querySelectorAll('[data-filter-toggle]');
  
  toggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const group = this.closest('.filter-group');
      if (group) {
        group.classList.toggle('is-open');
      }
    });
  });
  
  // Open first group by default
  const firstGroup = document.querySelector('.filter-group');
  if (firstGroup) {
    firstGroup.classList.add('is-open');
  }
}

/**
 * Quantity Selectors
 */
function initQuantitySelectors() {
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('.quantity-input');
    const minusBtn = selector.querySelector('[data-quantity-minus]');
    const plusBtn = selector.querySelector('[data-quantity-plus]');
    
    if (!input) return;
    
    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || 99;
    
    if (minusBtn) {
      minusBtn.addEventListener('click', () => {
        const value = parseInt(input.value) || min;
        input.value = Math.max(min, value - 1);
        input.dispatchEvent(new Event('change'));
      });
    }
    
    if (plusBtn) {
      plusBtn.addEventListener('click', () => {
        const value = parseInt(input.value) || min;
        input.value = Math.min(max, value + 1);
        input.dispatchEvent(new Event('change'));
      });
    }
  });
}

/**
 * Product Gallery
 */
function initProductGallery() {
  const mainImage = document.querySelector('[data-product-main-image]');
  const thumbnails = document.querySelectorAll('[data-product-thumbnail]');
  
  if (!mainImage || !thumbnails.length) return;
  
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      const newSrc = this.dataset.productThumbnail;
      const newSrcset = this.dataset.srcset;
      
      if (newSrc) {
        mainImage.src = newSrc;
        if (newSrcset) {
          mainImage.srcset = newSrcset;
        }
        
        thumbnails.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
      }
    });
  });
}

/**
 * Utility: Debounce
 */
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

/**
 * Cart Updates (AJAX)
 */
window.updateCart = async function(itemKey, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity
      })
    });
    
    const cart = await response.json();
    
    // Update cart count
    const cartCount = document.querySelector('[data-cart-count]');
    if (cartCount) {
      cartCount.textContent = cart.item_count;
    }
    
    return cart;
  } catch (error) {
    console.error('Cart update failed:', error);
    return null;
  }
};

/**
 * Add to Cart (AJAX)
 */
window.addToCart = async function(formData) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });
    
    const item = await response.json();
    
    // Update cart count
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    const cartCount = document.querySelector('[data-cart-count]');
    if (cartCount) {
      cartCount.textContent = cart.item_count;
    }
    
    return { item, cart };
  } catch (error) {
    console.error('Add to cart failed:', error);
    return null;
  }
};
